import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../Layout/PageHeader';
import '../../styles/projects.css';
import { projectsData } from '../../data/projects';
import { GiClick } from 'react-icons/gi';

const ProjectCard = ({ project, featured = false }) => (
  <article className={`project__card${featured ? '' : ' surface-card'}`}>
    <Link to={`/project/${project.id}`} className="project__link">
      <div className="project__image-wrap">
        <img
          src={project.imageUrl}
          alt={project.title}
          className={`project__image${project.imageClass ? ` ${project.imageClass}` : ''}`}
        />
      </div>
      <h3 className="project__title">{project.title}</h3>
      <p className="project__description">{project.cardDescription}</p>
      <span className="project__cta" aria-hidden="true">
        <GiClick />
      </span>
    </Link>
  </article>
);

const Portfolio = ({ embedded = false }) => {
  if (embedded) {
    return (
      <section className="projects projects--featured section" id="projects">
        <h2 className="section__title">
          Our featured projects <i className="ri-code-s-slash-fill" aria-hidden="true"></i>
        </h2>
        <div className="projects__container container">
          {projectsData.map((project) => (
            <ProjectCard key={project.id} project={project} featured />
          ))}
        </div>
      </section>
    );
  }

  return (
    <main className="page">
      <div className="page__inner">
        <PageHeader
          label="Portfolio"
          title="Featured projects"
          description="Apps and platforms we've designed, built, and shipped to production."
        />
        <div className="projects__container projects__container--page">
          {projectsData.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </main>
  );
};

export default Portfolio;
